import { Alert, Paper, Stack, Text } from '@mantine/core';
import { Redirect, useParams } from 'wouter';
import Link from '@/components/Link';
import Loader from '@/components/Loader';
import { ApiError } from '@/lib/api';
import {
  apiErrorText,
  mondayLinkPath,
  useResolveMonday,
} from '@/models/clientCompanies';

export default function MondayRedirect() {
  const { itemId } = useParams<{ itemId: string }>();
  const valid = /^\d+$/.test(itemId ?? '');
  const { data, isLoading, error } = useResolveMonday(itemId, valid);

  if (!valid)
    return (
      <Paper p="md">
        <Alert color="red">Not a Monday item ID: {itemId}</Alert>
      </Paper>
    );
  if (isLoading) return <Loader />;
  if (error || !data)
    return (
      <Paper p="md">
        <Alert color="gray">
          {error instanceof ApiError && error.status === 404
            ? `Monday item ${itemId} has no record in BO that you can open.`
            : apiErrorText(error)}
        </Alert>
      </Paper>
    );

  if (data.kind === 'deal') {
    if (data.owners.length === 1) {
      const path = mondayLinkPath(data.owners[0]);
      if (path) return <Redirect to={`~${path}`} replace />;
    }
    return (
      <Paper p="md">
        <Stack gap="xs">
          <Text>
            Services of Monday deal {itemId} are in several portfolios:
          </Text>
          {data.owners.map((o) => {
            const path = mondayLinkPath(o);
            return path ? (
              <Link key={`${o.kind}-${o.id}`} to={`~${path}`}>
                {o.kind === 'client_company' ? 'Company' : 'Contact'} #{o.id}
              </Link>
            ) : null;
          })}
        </Stack>
      </Paper>
    );
  }

  const path = mondayLinkPath(data);
  return path ? <Redirect to={`~${path}`} replace /> : null;
}
